import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { Subscription, firstValueFrom } from "rxjs";
import { AppInitializerService, AuthService, BASE_URL } from "@jwt";
import { LocalizationService } from "@app/core";
import { HttpClient } from "@angular/common/http";

@Component({
    selector: "welcome",
    templateUrl: "./welcome.component.html"
})
export class WelcomeComponent implements OnInit, OnDestroy {
    title = "Angular.Jwt.Core";

    isLoggedIn = false;
    subscription: Subscription | null = null;
    displayName: string;

    languageId: number;
    languages: any[] = [];

    constructor(
        @Inject(BASE_URL) private baseUrl: string,
        private authService: AuthService,
        private httpClient: HttpClient,
        public T: LocalizationService,
        private app: AppInitializerService) {
    }

    changeLanguage(item: any) {
        this.T.setLanguage(item.value);
    }

    ngOnInit() {
        this.subscription = this.authService.authStatus$.subscribe(status => {
            this.isLoggedIn = status;
            if (status) {
                const authUser = this.authService.getAuthUser();
                this.displayName = authUser ? authUser.displayName : "";
            }
        });

        firstValueFrom(this.httpClient.get<any>(`${this.baseUrl}/account/getLanguages`)).then((languages) => {
            const language = languages.find((x) => this.app.locale == x.culture);
            this.languageId = language?.id;
            this.languages = languages;
        });
    }

    ngOnDestroy() {
        // prevent memory leak when component is destroyed
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    logout() {
        this.authService.logout(true);
    }

    scrollToElement($element: any): void {
        console.log($element);
        setTimeout(() => {
            $element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        }, 200);

    }
}
